import HttpService from './httpService';
import config from '../../config';

// Preferencias de las tablas estándar (filtros, orden, anchos, columnas, densidad)
// guardadas por usuario en la BD. Todas las llamadas son silenciosas: si el
// backend no las tiene (503) la tabla sigue funcionando con localStorage.
class TablaPrefsApiService extends HttpService {
  async obtener(tabla) {
    return this.get(`tabla-prefs/${tabla}`, { silent: true });
  }

  async guardar(tabla, prefs) {
    return this.put(`tabla-prefs/${tabla}`, { prefs }, { silent: true });
  }

  async borrar(tabla) {
    return this.delete(`tabla-prefs/${tabla}`, { silent: true });
  }
}

export default new TablaPrefsApiService(config.REACT_APP_NODE_API);
